import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { Loading } from '../../uiComponents/Loading';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import VejledningAfsnitPresenter from '../../pageComponents/Vejledning/VejledningAfsnitPresenter';
import { RouteComponentProps } from 'react-router';
import { Vejledning } from '../../models/Vejledning';

export interface OpgavepakkeVejledningPresenterProps extends RouteComponentProps<any> {
}

interface OpgavepakkeVejledningPresenterState {
    vejledning?: Vejledning;
}

export default class VejledningPresenter extends React.Component<OpgavepakkeVejledningPresenterProps, OpgavepakkeVejledningPresenterState> {
    constructor(props: OpgavepakkeVejledningPresenterProps) {
        super(props);
        this.state = {
            vejledning: undefined
        };
    }

    componentDidMount() {
        this.getVejledning(this.props.match.params.id);
        window.scrollTo(0, 0);
    }

    getVejledning(id: string) {
        let self = this;
        let apicaller = createApiCaller();
        apicaller.getOpgavepakkeVejledning(id)
            .then((response) => {
                self.setState({ vejledning: response });
            });
    }

    componentWillReceiveProps(newProps: OpgavepakkeVejledningPresenterProps) {
        this.getVejledning(newProps.match.params.id);
    }

    getAfsnit() {
        if (this.state.vejledning !== undefined) {
            return this.state.vejledning.afsnit.map((a, i) => {
                if (a.overskrift !== undefined && a.overskrift.length > 0) {
                    return <VejledningAfsnitPresenter afsnit={a} key={i} index={i} />;
                }

                return undefined;
            });
        }

        return undefined;
    }

    scrollToSection = (id: string) => {
        let $element = $('#' + id);
        let offset = $element.offset();
        if (offset !== undefined) {
            $('html, body').animate({
                scrollTop: offset.top
            },                      1000);
        }
    }

    getIndholdsfortegnelse = () => {
        if (this.state.vejledning !== undefined) {
            return this.state.vejledning.afsnit.map((a, i) => {
                if (a.overskrift !== undefined && a.overskrift.length > 0) {
                    return <li key={i} onClick={x => this.scrollToSection('afsnit_' + i)}><a>{a.overskrift}</a></li>;
                }
                return undefined;
            });
        }

        return undefined;
    }   

    render() {
        const title = this.state.vejledning ? 'Vejledning ' + this.state.vejledning.opgavepakkenavn : 'Opgavepakke vejledning';

        return (
            <PageWrapper className='laerervejledning-presenter'>
                <PageTitle title={title} />
                <Loading isLoading={this.state.vejledning === undefined}>
                    <ContentWrapper>
                        <h1>Indholdsfortegnelse</h1>
                        <ul className='indholdsfortegnelse'>
                            {this.getIndholdsfortegnelse()}
                        </ul>
                        {this.getAfsnit()}
                    </ContentWrapper>
                </Loading>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgavepakke/OpgavepakkeVejledningPresenter.tsx